import { useCallback } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import { EmbeddedLayout } from "../components/EmbeddedLayout";
import { FlowAddPaymentMethod } from "../../Settings/components/payment/FlowAddPaymentMethod";
import { ManagePaymentMethod } from "../../Settings/components/payment/ManagePaymentMethod";
import {
  PATH_EMBEDDED_MANAGE_PAYMENT_METHOD,
  PATH_EMBEDDED_MANAGE_PAYMENT_METHOD_ADD
} from "../paths";
import { sendMessageToParent } from "../utils/postMessage";

export const RouteManagePaymentMethod: React.FC = () => {
  const history = useHistory();

  const goBackToManage = useCallback(() => {
    history.push(PATH_EMBEDDED_MANAGE_PAYMENT_METHOD);
  }, [history]);

  return (
    <EmbeddedLayout>
      <Switch>
        <Route path={PATH_EMBEDDED_MANAGE_PAYMENT_METHOD_ADD}>
          <FlowAddPaymentMethod
            basePath={PATH_EMBEDDED_MANAGE_PAYMENT_METHOD_ADD}
            onBack={goBackToManage}
            onNext={goBackToManage}
          />
        </Route>

        <Route path={PATH_EMBEDDED_MANAGE_PAYMENT_METHOD}>
          <ManagePaymentMethod
            onNext={() => sendMessageToParent("complete", { changed: true })}
            onAddNew={() => {
              history.push(PATH_EMBEDDED_MANAGE_PAYMENT_METHOD_ADD);
            }}
          />
        </Route>
      </Switch>
    </EmbeddedLayout>
  );
};
